export enum FrageTrinkmenge {
  NORMAL = 'normal',

  BRAUCHT_ANREGUNG = 'braucht_anregung',
}
